const CurrencyNotification = () => null;
export default CurrencyNotification;
